<template>
	<div class="exportReport" id="pdfPrint">
		<!-- <el-button type="primary" @click="onPrint()" class="noprint">打印</el-button> -->
		<el-button type="primary" @click="getPdf()" class="noprint">导出</el-button>

		<div class="topdiv"></div>
		<el-descriptions class="div1" title="" :column="2" border>
			<el-descriptions-item>
				<template slot="label">
					订单编号
				</template>
				{{form.recordCode}}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					充检站
				</template>
				<el-tag size="small">{{form.stationName}}</el-tag>
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					充电起始时间
				</template>
				{{form.beginTime}}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					充检桩编码
				</template>
				{{form.pileCode}}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					充电结束时间
				</template>
				{{form.endTime}}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					充检枪号
				</template>
				{{form.gunNo}}
			</el-descriptions-item>
		</el-descriptions>

		<el-descriptions title="" direction="vertical" :column="4" border>
			<el-descriptions-item label="车牌号">{{form.plateNumber}}</el-descriptions-item>
			<el-descriptions-item label="车型">{{form.carType}}</el-descriptions-item>
			<el-descriptions-item label="VIN">{{form.vin}}</el-descriptions-item>
			<el-descriptions-item label="电池类型">{{form.batteryType}}</el-descriptions-item>
		</el-descriptions>

		<div class="scorediv">
			<span class="sp1">电池健康评估综合得分</span>
			<b>{{form.score}}</b>
			<span class="sp2">{{form.suggest}}</span>
		</div>

		<div class="div2">
			<div class="radar1" style="width:324px;position: relative;">
				<div id="radar" class="allnav"></div>
				<img id="radarimg" src="" alt="" class="allnav">
				<p>一致性分析得分</p>
				<span class="consistency">{{form.consistency}}</span>
			</div>
			<div class="radar1">
				<div id="radar2" class="allnav"></div>
				<img id="radar2img" src="" alt="" class="allnav">
				<p>容量特性分析得分</p>
			</div>
			<div class="radar1">
				<div id="radar3" class="allnav"></div>
				<img id="radar3img" src="" alt="" class="allnav">
				<p>能量特性分析得分</p>
			</div>
		</div>
		<el-descriptions title="热失控风险" direction="vertical" :column="4" class="thermalRunawaydiv">
			<el-descriptions-item label="正常"><img v-show="form.thermalRunaway=='0'" src="../assets/images/ke.png">
			</el-descriptions-item>
			<el-descriptions-item label="一级告警"><img v-show="form.thermalRunaway=='1'" src="../assets/images/ke.png">
			</el-descriptions-item>
			<el-descriptions-item label="二级告警"><img v-show="form.thermalRunaway=='2'" src="../assets/images/ke.png">
			</el-descriptions-item>
			<el-descriptions-item label="三级告警"><img v-show="form.thermalRunaway=='3'" src="../assets/images/ke.png">
			</el-descriptions-item>
		</el-descriptions>

		<el-descriptions title="故障" direction="vertical" :column="6" border>
			<el-descriptions-item label="电压">
				<el-tag :type="form.failureMetrics[0]=='0'?'success':'danger'">{{form.failureMetrics[0]=='0'?'正常':'异常'}}
				</el-tag>
			</el-descriptions-item>
			<el-descriptions-item label="压差">
				<el-tag :type="form.failureMetrics[1]=='0'?'success':'danger'">{{form.failureMetrics[1]=='0'?'正常':'异常'}}
				</el-tag>
			</el-descriptions-item>
			<el-descriptions-item label="温度">
				<el-tag :type="form.failureMetrics[2]=='0'?'success':'danger'">{{form.failureMetrics[2]=='0'?'正常':'异常'}}
				</el-tag>
			</el-descriptions-item>
			<el-descriptions-item label="温差">
				<el-tag :type="form.failureMetrics[3]=='0'?'success':'danger'">{{form.failureMetrics[3]=='0'?'正常':'异常'}}
				</el-tag>
			</el-descriptions-item>
			<el-descriptions-item label="温升速率">
				<el-tag :type="form.failureMetrics[4]=='0'?'success':'danger'">{{form.failureMetrics[4]=='0'?'正常':'异常'}}
				</el-tag>
			</el-descriptions-item>
			<el-descriptions-item label="SOC变化">
				<el-tag :type="form.failureMetrics[5]=='0'?'success':'danger'">{{form.failureMetrics[5]=='0'?'正常':'异常'}}
				</el-tag>
			</el-descriptions-item>
		</el-descriptions>



		<!-- 单体电压变化曲线 -->
		<div id="voltage" class="allnav"></div>
		<img id="voltageimg" src="" alt="" class="allnav">
		<p>最高电压：是指充电过程中电压最高的单体电压值</p>
		<p>最低电压：是指充电过程中电压最低的单体电压值</p>
		<!-- 单体温度变化曲线 -->
		<div id="temperature" class="allnav"></div>
		<img id="temperatureimg" src="" alt="" class="allnav">
		<p>最大温度：是指充电过程中温度最高的单体温度值</p>
		<p>最小温度：是指充电过程中温度最低的单体温度值</p>

		<!-- 电压极差变化曲线 -->
		<div id="voltageRange" class="allnav"></div>
		<img id="voltageRangeimg" src="" alt="" class="allnav">
		<!-- 温度极差变化曲线 -->
		<div id="temperatureRange" class="allnav"></div>
		<img id="temperatureRangeimg" src="" alt="" class="allnav">
		<p>温度极差：温度极差是指同一时间内最高单体温度和最低单体温度的差值</p>
		<p>一般情况下，温度极差越小，代表电池的温度一致性越好</p>


	</div>
</template>

<script>
	import html2Canvas from 'html2canvas';
	import JsPDF from 'jspdf';
	export default {
		props: ['pileCode', 'recordCode', 'formPrint'], //父/子间通讯的桥梁
		data() {
			return {
				pileCodeStr: '',
				recordCodeStr: '',
				AuthorizationStr: '',
				form: {
					failureMetrics: ['', '', '', '', '', '']
				},
				radarchart1: '',
				radarchart2: '',
				radarchart3: '',
				voltagechart: '',
				tempchart: '',
				voltagechart2: '',
				tempchart2: '',
				
				voltageRangeList:[],tempRangeList:[],
			}
		},
		mounted() {
			let _this = this;
			var query = this.$route.query;
			_this.pileCodeStr = query.pileCode;
			_this.recordCodeStr = query.recordCode;
			_this.AuthorizationStr = query.Authorization;
			if (JSON.stringify(query) != '{}') {
				_this.onReportPreview();
			}


			this.$nextTick(() => {

				// _this.maxTempList = [10, 11, 13, 11, 12, 12, 9];
				// _this.minTempList = [1, 20, 2, 5, 3, 2, 0];
				// _this.tempTimeList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

				// _this.maxVoltageList = [10, 11, 13, 11, 12, 12, 9];
				// _this.minVoltageList = [1, 20, 2, 5, 3, 2, 0];
				// _this.voltageTimeList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

			})





		},
		methods: {
			onPrint: function() {
				window.print();
			},
			// 车检报告预览数据
			onReportPreview: function() {
				let _this = this;
				this.$api.post('/order/report/preview', {
						// Authorization: _this.AuthorizationStr == '' ? sessionStorage.getItem('Authorization') :
						// 	_this.AuthorizationStr,
						pileCode: _this.pileCode == undefined ? _this.pileCodeStr : _this.pileCode, //充电桩编号
						recordCode: _this.recordCode == undefined ? _this.recordCodeStr : _this.recordCode, //订单编号
					},
					function(response, context) {
						// _this.$message({
						// 	showClose: true,
						// 	message: "车检报告预览数据：" + response.message,
						// 	type: response.code == "200" ? 'success' : 'error'
						// });
						if (response.code == "200") {
							_this.onformat(response.data);
						}
					}
				);
			},

			onRadar: function() {
				let _this = this;
				_this.radarchart1 = this.$echarts.init(document.getElementById('radar'));

				let option = {
					legend: {
						show: false,
						data: ['Allocated Budget', 'Actual Spending']
					},
					radar: {
						// shape: 'circle',
						indicator: [{
								name: '电压',
								max: 6500
							},
							{
								name: '温度',
								max: 16000
							},
							{
								name: '电量',
								max: 30000
							},
							{
								name: '容量',
								max: 38000
							},
							{
								name: '内阻',
								max: 52000
							}
						]
					},
					series: [{
						name: 'Budget vs spending',
						type: 'radar',
						animation: false,
						data: [{
							value: [],
							name: 'Allocated Budget'
						}]
					}]
				};
				_this.radarchart1.setOption(option);
				window.addEventListener("resize", function() {
					_this.radarchart1.resize();
				});
				var imgSrc = _this.radarchart1.getDataURL();
				$('#radarimg').attr('src', imgSrc).show();
				$('#radarimg').css('display', 'none');
			},
			onRadar2: function() {
				let _this = this;
				_this.radarchart2 = this.$echarts.init(document.getElementById('radar2'));
				let option = {
					series: [{
						axisLine: {
							lineStyle: {
								width: 15,
								color: [
									[0.3, '#fd666d'],
									[0.7, '#ffaa00'],
									[1, '#00aa00']
								]
							}
						},
						animation: false,
						type: 'gauge',
						progress: {
							show: true,
							width: 18
						},
						axisTick: {
							show: false
						},
						splitLine: {
							length: 5,
							lineStyle: {
								width: 2,
							}
						},
						axisLabel: {
							distance: 5,
							fontSize: 12
						},
						anchor: {
							show: true,
							showAbove: true,
							size: 25,
							itemStyle: {
								borderWidth: 10
							}
						},
						title: {
							show: false
						},
						detail: {
							valueAnimation: true,
							fontSize: 40,
							offsetCenter: [0, '70%']
						},
						data: [{
							value: _this.form.capacityMetrics
						}]
					}]
				};
				_this.radarchart2.setOption(option);
				window.addEventListener("resize", function() {
					_this.radarchart2.resize();
				});
				var imgSrc = _this.radarchart2.getDataURL();
				$('#radar2img').attr('src', imgSrc).show();
				$('#radar2img').css('display', 'none');
			},
			onRadar3: function() {
				let _this = this;
				_this.radarchart3 = this.$echarts.init(document.getElementById('radar3'));
				let option = {
					series: [{
						type: 'gauge',
						animation: false,
						axisLine: {
							lineStyle: {
								width: 15,
								color: [
									[0.3, '#fd666d'],
									[0.7, '#ffaa00'],
									[1, '#00aa00']
								]
							}
						},
						pointer: {
							itemStyle: {
								color: 'auto'
							}
						},
						axisTick: {
							distance: -15,
							length: 8,
							lineStyle: {
								width: 2
							}
						},
						splitLine: {
							distance: -15,
							length: 15,
							lineStyle: {
								width: 2
							}
						},
						axisLabel: {
							color: 'auto',
							distance: 5,
							fontSize: 12
						},
						detail: {
							valueAnimation: true,
							formatter: '{value}',
							color: 'auto',
							fontSize: 40,
							offsetCenter: [0, '70%']

						},
						data: [{
							value: _this.form.energyIndicator
						}]
					}]
				};
				_this.radarchart3.setOption(option);
				window.addEventListener("resize", function() {
					_this.radarchart3.resize();
				});
				var imgSrc = _this.radarchart3.getDataURL();
				$('#radar3img').attr('src', imgSrc).show();
				$('#radar3img').css('display', 'none');
			},

			//电压
			onVoltage: function() {
				let _this = this;
				_this.voltagechart = this.$echarts.init(document.getElementById('voltage'));
				var option = {
					title: {
						text: '单体电压变化曲线',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {}
						}
					},
					legend: {
						icon: 'rect',
						itemWidth: 14,
						itemHeight: 5,
						itemGap: 10,
						data: ['最高电压', '最低电压'],
						right: '10px',
						top: '0px',
						textStyle: {
							fontSize: 12,
						}
					},
					grid: {
						x: 50,
						y: 50,
						x2: 45,
						y2: 40
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							textStyle: {},
							formatter: function (value, index) {
							    var date = new Date(value);
							    var texts =[(date.getHours()), date.getMinutes(), date.getSeconds()];
							    return texts.join(':');
							}
						},
						data: _this.voltageTimeList
					}],
					yAxis: [{
						type: 'value',
						// boundaryGap: [0, '100%'],
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							margin: 10,
							textStyle: {
								fontSize: 12
							},
							textStyle: {},
							formatter: '{value}V'
						},
						splitLine: {
							lineStyle: {
								color: '#57617B'
							}
						}
					}],

					series: [{
							name: '最高电压',
							type: 'line',
							smooth: true,
							animation: false,
							lineStyle: {
								normal: {
									width: 2
								}
							},
							yAxisIndex: 0,
							itemStyle: {
								normal: {
									color: '#B996F8'
								}
							},
							areaStyle: {
								color: {
									colorStops: [{
										offset: 0,
										color: 'rgba(185,150,248,0.3)'
									}, {
										offset: 0.8,
										color: 'rgba(185,150,248,0)'
									}],
								},
								shadowColor: 'rgba(0, 0, 0, 0.1)',
								shadowBlur: 10
							},
							data: _this.maxVoltageList
						},
						{
							show: false,
							name: '最低电压',
							type: 'line',
							smooth: true,
							animation: false,
							lineStyle: {
								normal: {
									width: 2
								}
							},
							yAxisIndex: 0,
							areaStyle: {
								color: {
									colorStops: [{
										offset: 0,
										color: 'rgba(3, 194, 236, 0.3)'
									}, {
										offset: 0.8,
										color: 'rgba(3, 194, 236, 0)'
									}],
								},
								shadowColor: 'rgba(0, 0, 0, 0.1)',
								shadowBlur: 10
							},
							itemStyle: {
								normal: {
									color: '#03C2EC'
								}
							},
							data: _this.minVoltageList
						}
					],
				};
				_this.voltagechart.setOption(option);
				window.addEventListener("resize", function() {
					_this.voltagechart.resize();
				});

				var imgSrc = _this.voltagechart.getDataURL();
				$('#voltageimg').attr('src', imgSrc).show();
				$('#voltageimg').css('display', 'none');
			},
			//温度
			onTemperature: function() {
				let _this = this;
				_this.tempchart = this.$echarts.init(document.getElementById('temperature'));
				var option = {
					title: {
						text: '单体温度变化曲线',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {}
						}
					},
					legend: {
						icon: 'rect',
						itemWidth: 14,
						itemHeight: 5,
						itemGap: 10,
						data: ['最高温度', '最低温度'],
						right: '10px',
						top: '0px',
						textStyle: {
							fontSize: 12,
						}
					},
					grid: {
						x: 50,
						y: 50,
						x2: 45,
						y2: 40
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							textStyle: {},
							formatter: function (value, index) {
							    var date = new Date(value);
							    var texts =[(date.getHours()), date.getMinutes(), date.getSeconds()];
							    return texts.join(':');
							}
						},
						data: _this.tempTimeList,
					}],
					yAxis: [{
						type: 'value',
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							margin: 10,
							textStyle: {
								fontSize: 12
							},
							textStyle: {},
							formatter: '{value}℃'
						},
						splitLine: {
							lineStyle: {
								color: '#57617B'
							}
						}
					}],
					series: [{
						name: '最高温度',
						type: 'line',
						smooth: true,
						animation: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: '#DA3914'
							}
						},
						data: _this.maxTempList,
					}, {
						name: '最低温度',
						type: 'line',
						smooth: true,
						animation: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: '#E8BE31'
							}
						},
						data: _this.minTempList,
					}],
				};
				_this.tempchart.setOption(option);
				window.addEventListener("resize", function() {
					_this.tempchart.resize();
				});

				var imgSrc = _this.tempchart.getDataURL();
				$('#temperatureimg').attr('src', imgSrc).show();
				$('#temperatureimg').css('display', 'none');
			},
			//电压极差
			onVoltageRange: function() {
				let _this = this;
				_this.voltagechart2 = this.$echarts.init(document.getElementById('voltageRange'));
				var option = {
					title: {
						text: '电压极差变化曲线',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {}
						}
					},
					legend: {
						icon: 'rect',
						itemWidth: 14,
						itemHeight: 5,
						itemGap: 10,
						data: ['电压极差'],
						right: '10px',
						top: '0px',
						textStyle: {
							fontSize: 12,
						}
					},
					grid: {
						x: 50,
						y: 50,
						x2: 45,
						y2: 40
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							textStyle: {},
							formatter: function (value, index) {
							    var date = new Date(value);
							    var texts =[(date.getHours()), date.getMinutes(), date.getSeconds()];
							    return texts.join(':');
							}
						},
						data: _this.voltageTimeList
					}],
					yAxis: [{
						type: 'value',
						// boundaryGap: [0, '100%'],
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							margin: 10,
							textStyle: {
								fontSize: 12
							},
							textStyle: {},
							formatter: '{value}V'
						},
						splitLine: {
							lineStyle: {
								color: '#57617B'
							}
						}
					}],

					series: [{
						name: '电压极差',
						type: 'line',
						smooth: true,
						animation: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						yAxisIndex: 0,
						itemStyle: {
							normal: {
								color: '#00aa00'
							}
						},
						data: _this.voltageRangeList,
					}],
				};
				_this.voltagechart2.setOption(option);
				window.addEventListener("resize", function() {
					_this.voltagechart2.resize();
				});
				var imgSrc = _this.voltagechart2.getDataURL();
				$('#voltageRangeimg').attr('src', imgSrc).show();
				$('#voltageRangeimg').css('display', 'none');
			},
			//温度极差
			onTemperatureRange: function() {
				let _this = this;
				_this.tempchart2 = this.$echarts.init(document.getElementById('temperatureRange'));
				var option = {
					title: {
						text: '温度极差变化曲线',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {}
						}
					},
					legend: {
						icon: 'rect',
						itemWidth: 14,
						itemHeight: 5,
						itemGap: 10,
						data: ['温度极差'],
						right: '10px',
						top: '0px',
						textStyle: {
							fontSize: 12,
						}
					},
					grid: {
						x: 50,
						y: 50,
						x2: 45,
						y2: 40
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							textStyle: {},
							formatter: function (value, index) {
							    var date = new Date(value);
							    var texts =[(date.getHours()), date.getMinutes(), date.getSeconds()];
							    return texts.join(':');
							}
						},
						data: _this.tempTimeList,
					}],
					yAxis: [{
						type: 'value',
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#57617B'
							}
						},
						axisLabel: {
							margin: 10,
							textStyle: {
								fontSize: 12
							},
							textStyle: {},
							formatter: '{value}℃'
						},
						splitLine: {
							lineStyle: {
								color: '#57617B'
							}
						}
					}],
					series: [{
						name: '温度极差',
						type: 'line',
						smooth: true,
						animation: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: '#00aa00'
							}
						},
						data:_this.tempRangeList,
					}],
				};
				_this.tempchart2.setOption(option);
				window.addEventListener("resize", function() {
					_this.tempchart2.resize();
				});
				var imgSrc = _this.tempchart2.getDataURL();
				$('#temperatureRangeimg').attr('src', imgSrc).show();
				$('#temperatureRangeimg').css('display', 'none');
			},
			
			onformat:function(data){
				let _this=this;
				_this.form = {
					recordCode: data.recordCode,
					stationName: data.stationName,
					beginTime: data.beginTime,
					endTime: data.endTime,
					gunNo: data.gunNo,
					pileCode: data.pileCode,
					recordCode: data.recordCode,
					stationName:data.stationName,
					beginTime: data.beginTime,
					endTime: data.endTime,
					gunNo: data.gunNo,
					pileCode: data.pileCode,
					plateNumber: data.plateNumber,
					carType: data.carType,
					vin: data.vin,
					batteryType: data.batteryType,
					score: data.score,
					suggest: data.suggest,
					consistency: data.consistency,
					capacityMetrics: data.capacityMetrics,
					energyIndicator: data.energyIndicator,
					thermalRunaway: data.thermalRunaway,
					failureMetrics: data.failureMetrics,
				};
				
				_this.maxTempList = data.singleTempInfo.singleMaxTemp;
				_this.minTempList = data.singleTempInfo.singleMinTemp;
				_this.tempTimeList = data.singleTempInfo.dateTime;
				_this.tempRangeList=data.singleTempInfo.tempRange;
				
				
				_this.maxVoltageList = data.singleVoltageInfo.singleMaxVoltage;
				_this.minVoltageList = data.singleVoltageInfo.singleMinVoltage;
				_this.voltageTimeList =data.singleVoltageInfo.dateTime;
				_this.voltageRangeList=data.singleVoltageInfo.voltageRange;
				
				_this.onTemperature();
				_this.onVoltage();
				
				_this.onVoltageRange();
				_this.onTemperatureRange();
				
				_this.onRadar();
				_this.onRadar2();
				_this.onRadar3();
				
			},
			
			getPdf() {
				var title = '报告_'+new Date().toLocaleString(); // 导出的pdf文件名
				html2Canvas(document.querySelector('#pdfPrint'), { //导出的html元素
					allowTaint: true
				}).then(function(canvas) {
					let contentWidth = canvas.width;
					let contentHeight = canvas.height;
					let pageHeight = contentWidth / 592.28 * 841.89;
					let leftHeight = contentHeight;
					let position = 0;
					let imgWidth = 595.28;
					let imgHeight = 592.28 / contentWidth * contentHeight;
					let pageData = canvas.toDataURL('image/jpeg', 1.0);
					let PDF = new JsPDF('', 'pt', 'a4');
					if (leftHeight < pageHeight) {
						PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
					} else {
						while (leftHeight > 0) {
							PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
							leftHeight -= pageHeight;
							position -= 841.89;
							if (leftHeight > 0) {
								PDF.addPage();
							}
						}
					}
					PDF.save(title + '.pdf');
				})
			},
		},
		watch: {
			formPrint: function(newValue, oldValue) {
				console.log("formPrint:", newValue);
				
				this.onformat(newValue);
				
				this.$emit('feedback', '200', '2');
			},
		}
	}
</script>

<style lang="scss" >
	html,
	body,
	#app {
		height: auto !important;
		background: white;
		-webkit-print-color-adjust: exact;
	}
	
	.main {
		background-color: white !important;
	}

	@media print {
		#app {
			background-color: white !important;
		}

		div.allnav,
		.noprint {
			display: none;
			background-color: white !important;
		}

		img.allnav {
			display: inline !important;
		}
		.el-descriptions-item__content,span, b,p,*{
			color: #606266 !important;
		}
	}

	.exportReport {
		margin: auto;
		width: 100%;
		max-width: 1100px;
		background-color: white !important;
		padding: 30px 20px;

		.noprint {
			position: fixed;
			right: 15%;
			top: 50%;
		}

		.el-descriptions {
			margin: 40px 0px;
		}

		.allnav {
			width: 1020px;
			height: 400px;
			border: 1px solid #e4e7ed;
			padding-top: 20px;
			margin-top: 80px;
			margin-bottom: 10px;
		}


		.topdiv {
			background-image: url('../assets/images/a.webp');
			background-repeat: no-repeat;
			width: 100%;
			height: 380px;
			text-align: center;
			line-height: 200px;
			padding: 20px 0px;
			background-position: right;
		}

		.div1 {
			margin: 20px 0px;
		}

		.scorediv {
			background-color: #BDF7FD;
			width: 100%;
			height: 100px;
			margin: 20px 0px;

			.sp1 {
				line-height: 140px;
				margin-left: 50px;
				font-size: 18px;
			}

			b {
				font-size: 60px;
				margin: 20px;
			}

			.sp2 {
				font-size: 14px;
				margin-left: 100px;
			}
		}

		.div2 {
			background-color: greenyellow;
			background-image: linear-gradient(#DEFAFC, #FFFFFF);
			height: 300px;
			width: 100%;

			.radar1 {
				width: 32%;
				height: 300px;
				display: inline-block;
				float: left;
				text-align: center;

				.allnav {
					width: 288px;
					height: 260px;
					margin: 0px;
					border-width: 0px;
				}

				p {
					line-height: 40px;
					margin: 0px;
					color: #308ee0;
					font-size: 16px;
					font-weight: 600;
				}
			}

			.consistency {
				position: absolute;
				top: 0px;
				bottom: 0px;
				left: 130px;
				margin: auto;
				font-size: 40px;
				width: auto;
				display: inline-table;
				color: #308ee0;
			}
		}

		.thermalRunawaydiv .el-descriptions-row {
			.el-descriptions-item__cell {
				text-align: center;
				color: white;
				line-height: 40px;
				padding: 0px;
			}

			.el-descriptions-item__content {
				padding: 0px;
			}

			img {
				width: 30px;
			}

			th:nth-child(1) {
				background-color: #00B050;
			}

			th:nth-child(2) {
				background-color: #ffaf00;
			}

			th:nth-child(3) {
				background-color: #FF0000;
			}

			th:nth-child(4) {
				background-color: #C00000;
			}
		}
	}
</style>
